class CustomBackToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.wrapper = this.closest('.page-wrapper');
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.schedule = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    };
    window.addEventListener('scroll', this.schedule, { ...options, passive: true });
    this.wrapper?.addEventListener('scroll', this.schedule, { ...options, passive: true });
    window.addEventListener('resize', this.schedule, options);
    this.observer = new ResizeObserver(this.schedule);
    this.observer.observe(document.body);
    if (this.wrapper) this.observer.observe(this.wrapper);
    const main = document.querySelector('main');
    if (main) this.observer.observe(main);
    this.button.addEventListener('click', () => {
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      (this.nestedScroll() ? this.wrapper : window).scrollTo({ top: 0, behavior: reduced ? 'instant' : 'smooth' });
      // Keep keyboard focus useful after the fixed button hides at the top.
      const target = document.querySelector('.custom-header__logo-link, a[href="#MainContent"]');
      target?.focus({ preventScroll: true });
    }, options);
    this.update();
  }

  update() {
    const nested = this.nestedScroll();
    const total = nested ? this.wrapper.scrollHeight - this.wrapper.clientHeight : document.documentElement.scrollHeight - window.innerHeight;
    const position = nested ? this.wrapper.scrollTop : window.scrollY;
    const progress = total > 0 ? Math.max(0, Math.min(100, position / total * 100)) : 0;
    this.button.style.setProperty('--scroll-progress', progress.toFixed(2));
    this.button.hidden = position < (Number(this.dataset.threshold) || 300) || total <= 0;
  }

  nestedScroll() { return this.wrapper && /auto|scroll/.test(getComputedStyle(this.wrapper).overflowY); }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
  }
}
if (!customElements.get('custom-back-to-top')) customElements.define('custom-back-to-top', CustomBackToTop);
